const initialState = {
    serverType: "dz", 
    BASE_URL : process.env.REACT_APP_BASE_URL_DZ,
    API_BASE_URL : process.env.REACT_APP_API_BASE_URL_DZ

};

const serverTypeReducer = (state = initialState, action) => {
    console.log("actuopghoi ")
    switch (action.type) {
        case "SET_SERVER_TYPE":
            return {  serverType: action.payload , BASE_URL :action.payload =="dz" ? process.env.REACT_APP_BASE_URL_DZ : process.env.REACT_APP_BASE_URL_EU, API_BASE_URL :action.payload =="dz" ? process.env.REACT_APP_API_BASE_URL_DZ:process.env.REACT_APP_API_BASE_URL_EU};
        default:
            return state ;
    }
};

export default serverTypeReducer;